export const environment = {
  production: false,
  host: "https://qabackend.cronoleo.com",
  appHost: "https://cronoleo.com:8100",
  apiUrl: "https://servicio.cronoleo.com/", //server node
  apiUrl2: "https://qabackend.cronoleo.com/testproducts/src/api/",
  urlFacturacion: "https://qabackend.cronoleo.com/facturacion/apifacturacion",
  urlDireccionEnvios:
    "https://qabackend.cronoleo.com/direccionenvioestudiante/apidireccionenvios",
  urlReferidos: "https://qabackend.cronoleo.com/usuario/apireferidos",
  urlReferidosTest: "https://qabackend.cronoleo.com/usuario/apireferidos",
  ulrCalificaEstudian:
    "https://qabackend.cronoleo.com/cursos/obtener-estadisticas",
  urlLogin: "https://qabackend.cronoleo.com/login",
  urlAutores: "https://qabackend.cronoleo.com/autores/apiautores",
  urlEmail: "https://cronoleo.com:3000/send-email",
  urlColeccion: "https://qabackend.cronoleo.com/coleccion/apicoleccion",
  apiToken:
    "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIxMjM0NTY3ODkwIiwibmFtZSI6IkpvaG4gRG9lIiwiaWF0IjoxNTE2MjM5MDIyfQ.SflKxwRJSMeKKF2QT4fwpMeJf36POk6yJV_adQssw5c",
  epaycoUrl: "https://epayco.cronoleo.com/",
  urlCompra: "https://qabackend.cronoleo.com/compras",
  urlEstudios: "https://qabackend.cronoleo.com/estudios/apiestudios",
  urlExpLaboral:
    "https://qabackend.cronoleo.com/experiencialab/apiexperiencialaboral",
  urlPremios: "https://qabackend.cronoleo.com/premios/apipremios",
  urlUserimg: "https://qabackend.cronoleo.com/userimg/apiimagenusuario",
  urlPerfil: "https://qabackend.cronoleo.com/usuario/apiperfil",
  urlActividades: "https://qabackend.cronoleo.com/actividades/apiactividades",
  urlCursos: "https://qabackend.cronoleo.com/cursos/apicursos",
  urlinstituciones:
    "https://qabackend.cronoleo.com/instituciones-admin/api-index-admin",
  urlLibros: "https://qabackend.cronoleo.com/productos/apiproductos",
  urlForo: "https://qabackend.cronoleo.com/categoriaforo/apiforo",
  urlEvento: "https://qabackend.cronoleo.com/evento/apievento",
  urlSearch: "https://qabackend.cronoleo.com/search/apisearch",
  urlProductosAudio: "https://qabackend.cronoleo.com/productos-audios-admin",
  urlEpub: "https://qabackend.cronoleo.com/productos/api-get-epub",
  urlListBooks: "https://qabackend.cronoleo.com/productos/api-get-all-books",
  urlGetBookById: "https://qabackend.cronoleo.com/productos/api-get-book-by-id",
  urlespera: "https://qabackend.cronoleo.com/usuario/apilista",
  urlwork: "https://qabackend.cronoleo.com/usuario/apitrabaja",
  urlcontac: "https://qabackend.cronoleo.com/usuario/apicontacto",
  urlFront: "http://localhost:4200/",
  prefiBillSuscription: "PRUEBS-",
  pefiBillBook: "PRUEBL-",
  urlConfirmation: "https://qabackend.cronoleo.com/compras/confirmacion",
};

